module.exports = __webpack_public_path__ + "img/beer_id-30.74bcb033.png";